<template>
  <EditForm :group="group"/>
</template>

<script>
import EditForm from '@/pages/admin/group/EditForm'
import GroupService from '@/services/GroupService'

export default {
  components: {EditForm},
  data: () => ({
    group: GroupService.getDefaultItem()
  }),
  computed: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/group/Add.vue